import React from "react";
import { useApp } from "../contexts/AppContext";
import { ScrollText } from "lucide-react";
import RichText from "../components/RichText";

export default function Rules() {
  const { t, settings } = useApp();
  const w = Number(settings?.rules_content_width) || 1024;
  return (
    <div className="mx-auto px-6 md:px-10 pt-10 pb-20" style={{ maxWidth: `${w}px` }} data-testid="rules-page">
      <div className="flex items-center gap-3 mb-6">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#FFD93D] shadow-[0_6px_0_#B8860B]">
          <ScrollText className="text-[#0B1D3A]" strokeWidth={2.5} />
        </span>
        <h1 className="font-fredoka text-4xl md:text-5xl font-bold text-[#0B1D3A]"><RichText k="rules_title" /></h1>
      </div>
      <div className="rounded-3xl bg-white p-7 md:p-9 shadow-[0_12px_40px_-10px_rgba(11,29,58,0.1)] border border-[#0B1D3A]/5">
        <RichText k="rules_body" as="div" className="font-nunito text-lg leading-relaxed text-[#0B1D3A]/85 whitespace-pre-line" />
      </div>
    </div>
  );
}
